export function getTargetDate() {
  const now = new Date();
  const day = now.getDay();        // 0=Sun, 1=Tue, …, 5=Fri, 6=Sat
  const MONDAY = 1;
  const FRIDAY  = 5;
  const beforeHour = 15;
  
  // days until the *next* delivery window
  const daysUntilNextOrder = (
    // if we’re already between Tue-after-3pm and Fri-before-3pm,
    // go to this Fri; otherwise go to next Tue or Fri
    (day > MONDAY && day < FRIDAY) ||
    (day === FRIDAY && now.getHours() < beforeHour) ||
    (day === MONDAY && now.getHours() >= beforeHour)
      ? (FRIDAY - day + 7) % 7
      : (MONDAY - day + 7) % 7
  );

  const target = new Date(now);
  target.setDate(now.getDate() + daysUntilNextOrder);
  target.setHours(beforeHour, 0, 0, 0);
  return target;
}
